(() => {
  'use strict';

  angular
    .module('uwAgenda.settings.aiagent')
    .controller('AiAgentTranscriptionsController', ['TranscriptionPaginationService', AiAgentTranscriptionsControllerFn]);

  function AiAgentTranscriptionsControllerFn(TranscriptionPaginationService) {
    const vm = this;
    vm.overview = TranscriptionPaginationService;
  }
})();
